import { type ReactNode } from 'react'
import TableCell from '@mui/material/TableCell'

type Field = {
  label: string
  value: ReactNode
  breakWord?: boolean
}

export const renderCells = (fields: (Field | null)[]): ReactNode =>
  fields
    .filter((field): field is Field => field !== null)
    .map(({ label, value, breakWord }) => (
      <TableCell sx={{ width: 'auto', wordBreak: breakWord ? 'break-word' : 'initial' }} key={label} data-label={label}>
        {value}
      </TableCell>
    ))
